const colors = {
  primary: '#f5f5f5',
  secondary: '#fff',
  brand: '#ffbe5d',
};

export default colors;
